module.exports = __webpack_public_path__ + "img/COMBO PALM BW.e2f3762.svg";